<template>
  <v-app >
    <v-main>
      <!-- Mobile app bar, hamburger menu, and menu items -->
      <v-app-bar
        v-if="$vuetify.breakpoint.mobile"
        dense
        fixed
        color="rgba(255, 255, 255, 0.5)"
      >
        <v-img
          src="../public/static/gdot-logo.png"
          class="shrink mr-2"
          width="110"
          contain
          @click="navigateToGdot"
        />
        <v-spacer></v-spacer>
        <HelpText
          v-if="$vuetify.breakpoint.mobile"
          :slide-title="slideTitle"
          :help-text="helpText"
          :about-text="aboutText"
          :show-help-text="showHelpText"
          :show-about-text="showAboutText"
          :toggle-help-text="toggleHelpText"
          :toggle-about-text="toggleAboutText"
        />
        <v-app-bar-nav-icon @click="menu = true"></v-app-bar-nav-icon>
      </v-app-bar>
      <v-menu
        v-model="menu"
        min-width="50%"
        :position-x="1000"
        transition="scroll-y-transition"
        max-height="100vh"
      >
        <v-list dense nav>
          <v-list-item-group v-model="workShopSlide" color="primary" mandatory>
            <v-list-item
              v-for="(page, index) in slideLabels"
              :key="page"
              link
              @click="goToSlide(index)"
              @mouseover="hoverHandler(e)"
            >
              <v-list-item-content class="text-center">
                <v-list-item-title v-html="page"> </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <!-- Main content - applies to desktop and mobile -->
      <v-row>
        <v-col
          :cols="$vuetify.breakpoint.mobile ? `12` : `10`"
          style="overflow:hidden; padding: 0%"
        >
          <Workshop
            :work-shop-slide="workShopSlide"
            :help-text="helpText"
            :about-text="aboutText"
            :slide-title="slideTitle"
            :show-help-text="showHelpText"
            :show-about-text="showAboutText"
            :slide-visited="slideVisited"
            :get-slide-title="getSlideTitle"
            :get-slide-help-text="getSlideHelpText"
            :get-slide-about-text="getSlideAboutText"
            :toggle-help-text="toggleHelpText"
            :toggle-about-text="toggleAboutText"
            @update-slide="goToSlide"
          />
        </v-col>
        <v-col
          cols="2"
          v-if="!$vuetify.breakpoint.mobile"
          style="padding: 0% !important;"
        >
          <v-navigation-drawer
            right
            permanent
            color="rgba(255, 255, 255, 0.1)"
            width="100%"
            @mouseover="mouseoverEvent()"
          >
            <v-list dense nav>
              <v-list-item-group
                v-model="workShopSlide"
                color="primary"
                mandatory
              >
                <v-list-item
                  v-for="(page, index) in slideLabels"
                  :key="page"
                  link
                  @click="goToSlide(index)"
                  @mouseover="hoverHandler(page, index)"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      :class="[
                        $vuetify.breakpoint.mdAndUp ? 'text-h4' : 'body-1'
                      ]"
                      v-html="page"
                    >
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item-content
                  :style="{
                    'padding-top': $vuetify.breakpoint.mobile ? `0%` : `15%`
                  }"
                  :class="{ logos: !$vuetify.breakpoint.mobile }"
                >
                  <v-img
                    src="../public/static/gdot-logo.png"
                    @click="navigateToGdot"
                    id="gdot-logo"
                    :class="{ logoMobile: $vuetify.breakpoint.mobile }"
                  />
                </v-list-item-content>
              </v-list-item-group>
            </v-list>
          </v-navigation-drawer>
        </v-col>
      </v-row>

      <!-- Comment reminder modal -->
      <!-- <v-dialog
        v-model="showCommentReminder"
        :width="$vuetify.breakpoint.mobile ? `90%` : `50%`"
        style="min-height: 50% !important;"
      >
        <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            Before you go
          </v-toolbar-title>
        </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="12" class="text-center">
                <div>
                  <p class="text-justify help reminder">
                  Did you review each executive summary prepared by the Proposers interested in the I-285/I-20 East Interchange project? 
                  </p>
                  <p class="text-justify help reminder">
                  <strong>Remember to submit comments for the executive summaries by March 8, 2022.</strong>
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog> -->
    </v-main>
  </v-app>
</template>

<script>
import Workshop from "./components/Workshop.vue";
import HelpText from "@/components/HelpText.vue";

export default {
  name: "App",
  components: {
    Workshop,
    HelpText
  },
  updated() {
    // does not get updated when item clicked
    // debugger
  },
  // opted not to go this route (would be confusing for user)
  // created() {
  //   window.addEventListener("beforeunload", function(e) {
  //     e.preventDefault();
  //     this.showCommentReminder = true
  //     let confirmationMessage = "Please leave a comment!"; //Not read in most browsers. needs to be non-empty
  //     (e || window.event).returnValue = confirmationMessage; //Gecko + IE
  //     return confirmationMessage; //Webkit, Safari, Chrome
  //   });
  // },
  props: {
    aboutIcon: {
      type: String,
      default: "mdi-account-question"
    },
    helpIcon: {
      type: String,
      default: "mdi-information"
    }
  },
  data: () => ({
    currentSlide: 0,
    hoveredOnce: false,
    workShopSlide: 0,
    slideLabels: [
      // "Welcome",
      // "Executive Summary",
      "Project Design",
      "Environmental <br> Impacts",
      "Air/Noise <br> Impacts",
      "Property <br> Acquisitions"
      // "Comment Station"
    ],
    menu: false,
    slideTitle: "",
    helpText: "",
    aboutText: "",
    showHelpText: true,
    showAboutText: false,
    onCommentStationSlide: false,
    // showCommentReminder: false,
    slideVisited: [0, 0, 0, 0],
  }),
  mounted() {
    this.getSlideTitle();
    this.getSlideHelpText();
    this.getSlideAboutText();
    this.slideVisited[this.workShopSlide] = 1;
  },
  watch: {
    workShopSlide() {
      this.getSlideTitle();
      this.getSlideHelpText();
      this.getSlideAboutText();
      this.$gtag.pageview({
        page_path: this.workShopSlide
      });
      if (!this.slideVisited[this.workShopSlide]) {
        this.showHelpText = true;
        this.slideVisited[this.workShopSlide] = 1;
      }
    }
  },
  methods: {
    goToSlide(slide) {
      debugger
      // check if you can see the url here
      this.workShopSlide = slide;
      // let lastSlide = this.slideVisited.length - 1;
      // if (slide == lastSlide) {
      //   debugger
      //   this.showCommentReminder = true;
      //   this.onCommentStationSlide = true;
      // } 
      // if (slide == lastSlide) {
      //   debugger
      //   this.showCommentReminder = true;
      //   this.onCommentStationSlide = true;
      // } 
      // if (this.onCommentStationSlide) {
      //   debugger
      //   this.onCommentStationSlide = false;
      //   this.showCommentReminder = true;
      // }
    },
    async getSlideHelpText() {
      const svg = await import(`@/data/slide${this.workShopSlide + 2}`);
      this.helpText = svg.default.helpText;
    },
    async getSlideAboutText() {
      const svg = await import(`@/data/slide${this.workShopSlide + 2}`);
      this.aboutText = svg.default.aboutText;
    },
    async getSlideTitle() {
      const svg = await import(`@/data/slide${this.workShopSlide + 2}`);
      this.slideTitle = svg.default.slideTitle;
    },
    toggleHelpText() {
      this.showHelpText = !this.showHelpText;
    },
    toggleAboutText() {
      this.showAboutText = !this.showAboutText;
    },
    hoverHandler(page, index) {
      // functionality temporarily removed
      console.log(page, index)
      // if (!this.hoveredOnce) {
      //   debugger
      //   this.showCommentReminder = true;
      //   this.hoveredOnce = true
      // } else {
      //   console.log(page, index)
      // }
    },
    navigateToGdot() {
      window.open('http://www.dot.ga.gov/', 'a_blank')
    }
  }
};
</script>
<style scoped>
.logos {
  padding-left: 10%;
  padding-right: 10%;
}
.logoMobile {
  padding-left: 0;
  margin-left: -5%;
  margin-top: -5%;
  margin-bottom: -12%;
}
.reminder {
  margin: 0.5em;
}
#gdot-logo:hover {
  cursor: pointer;
}
</style>
